import { React, ts } from '_core';

import Chart from './chart';
import Form from './form';
import { DraftParams, Params } from './types';

type BasketCompareTurnoverProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  params: Params | DraftParams;
  setParams: (_p: DraftParams) => void;
  title: string;

  fullScreen?: boolean;
  context?: ts.types.basket.BasketAnalysisContext;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'backtest_turnover_analysis', string>;
};

const BasketCompareTurnover = ({
  id,
  readOnly,
  widgetKey,
  params,
  setParams,
  mode,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  context,
  title,
}: BasketCompareTurnoverProps) => {
  const renderJobComponent = () => (
    <>
      <Chart
        id={id}
        readOnly={readOnly}
        widgetKey={widgetKey}
        fullScreen={fullScreen}
        loadWidgetData={loadWidgetData}
        portfolios={widgetPaths['backtest_turnover_analysis']}
        context={context}
        params={params as Params}
        title={title}
      />
    </>
  );

  return <>{mode == 'edit' ? <Form params={params} setParams={setParams} /> : renderJobComponent()}</>;
};

export default BasketCompareTurnover;
